type MediaQueries = {
  [key: string] : string
};

const breakpoints = [480, 667, 768, 992, 1200, 1440, 1680];

const names = [`xs`, `sm`, `md`, `lg`, `xl`, `xxl`, `xxxl`];

export const mediaQueries = breakpoints.reduce<MediaQueries>((acc, bp, i) => {
  acc[names[i]] = `@media (min-width: ${bp}px)`;
  return acc;
}, {});

export const pxToRem = (px : number) => {
  return (Math.floor(px * 1000 / 16) / 1000 + 'rem');
}

export const weights = {
  regular: 400,
  medium: 500,
  semi: 600,
  bold: 700,
  black: 900
};

export const fonts = {
  sans: `Instrument Sans, Arial`,
  display: `Instrument Sans, Arial`,
  mono: `Instrument Sans, monospace`
}

export const fontSizeLineHeight = (fontSize : number, lineHeight : number) => {
  const fontValue = pxToRem(fontSize);
  const lhValue = Math.floor(lineHeight / fontSize * 1000) / 1000;
  return (`font-size: ${fontValue}; line-height: ${lhValue};`);
}

export const transition = (transitionProps = 'all') => {
  return Array.isArray(transitionProps) ? transitionProps.map(prop => `0.3s ease ${prop}`).join(",") : `0.3s ease ${transitionProps}`;
}

export const rgbaFromHex = (hex : string, transparency : number) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  return `rgba(${r},${g},${b},${(transparency / 100).toFixed(4)})`;
}
